import React from 'react';
import AppLayout from '../components/AppLayout';
import GameTheoryDashboard from '../components/analytics/GameTheoryDashboard';

export default function GameTheoryPage() {
  return (
    <AppLayout>
      <GameTheoryDashboard />
    </AppLayout>
  );
}
